/***
 * plugin vystreli udalost eventName v pripade, ze se targetItem zobrazi ve viewportu alespon z takove procentualni casti, ktera je definovana parametrem minVisiblePart
 *  - v udalosti je vystreleno pole jquery objektu polozek, ktere podmince vyhoveli
 *  - kazda polozka se v evente muze objevit jen jednou
 *  - opakove vystreleni eventy je mozne jen po nove inicializaci pluginu
 * @type {jQuery}
 */

var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "triggerInViewport";

var DEFAULTS = {
	targetItem: null,				// null = pouzije se prvni potomek, jinak je mozne nastavit libovolny selektor potomka
	minVisiblePart: 40,				// minimalni procentualni cast vysky elementu, ktera se pri vystreleni udalosti zohledni
	eventName: 'IS_IN_VIEWPORT', 	// nazev vystrelene udalosti
	triggerEventOn: null			// null - vystreli udalost na selektoru, ze ktereho je plugin volan, jinak na libovolnem selektoru potomka
};

// The actual plugin constructor
function TriggerInViewport(element, options) {
	this.element = element;
	this.$me = $(this.element);

	this.options = $.extend(true, {}, DEFAULTS, options);

	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;

	this.data = {};

	this.initialise();
}

/**
 * init
 */
TriggerInViewport.prototype.initialise = function() {
	var self = this;

	self.data.$targetItems = self.getTargetItems();

	self.detectItemsVisibility();
	self.bindEvents();
};

/**
 *  nabindovani udalosti scroll/resize/orientationChange/ajaxComplete, ktere znovuinicializuji detekci viditelnosti polozek
 */
TriggerInViewport.prototype.bindEvents = function() {
	var self = this,
		id = Date.now();

	$(window).off('scroll.scroll' + id).on('scroll.scroll' + id, function(e){
		clearTimeout($.data(this, 'scrollCheck' + id ));
		$.data(this, 'scrollCheck' + id, setTimeout(function() {
			self.detectItemsVisibility();
		}, 250));
	});

	$(window).off('resize.resize' + id).on('resize.resize' + id, function(){
		clearTimeout($.data(this, 'resizeCheck' + id));
		$.data(this, 'resizeCheck' + id, setTimeout(function() {
			self.detectItemsVisibility();
		}, 250));
	});

	$(window).off('orientationchange.orientationchange' + id).on('orientationchange.orientationchange' + id, function(){
		self.detectItemsVisibility();
	});

	$(document).on('ajaxComplete', function(){
		self.data.$targetItems = self.getTargetItems();
		self.detectItemsVisibility();
	});
};

/**
 * nacteni cilovych polozek
 * @returns {*} jQuery object s cilovymi polozkami
 */
TriggerInViewport.prototype.getTargetItems = function() {
	var self = this,
		$result;

	// prvni potomci selektoru
	if (self.options.targetItem === null) {
		$result = self.$me.children();
	}

	// potomci podle selektoru v option
	else {
		$result = self.$me.find(self.options.targetItem);
	}

	return $result;
};

/**
 * detekce viditelnosti cilovych polozek
 * - jquery objekty detekovanych polozek se ulozi do pole, ktere se vystreli s udalosti
 */
TriggerInViewport.prototype.detectItemsVisibility = function() {
	var self = this,
		windowHeight = $(window).height(),
		scrollTop = $(window).scrollTop(),
		$this,
		itemOffset,
		itemHeight,
		triggerInViewport,
		triggerInViewportPercentage,
		triggerInViewportItems = [];

	if (self.data.$targetItems.length == 0) return;

	self.data.$targetItems.each(function() {
		$this = $(this);

		if (typeof($this.data('triggerInViewportProcessed')) == 'undefined') {
			itemOffset = $this.offset().top;
			itemHeight = $this.outerHeight();

			triggerInViewport = (windowHeight + scrollTop) - itemOffset;

			if (triggerInViewport > itemHeight) {
				triggerInViewport = itemHeight;
			}
			if (triggerInViewport < 0) {
				triggerInViewport = 0;
			}

			triggerInViewportPercentage = (100 * triggerInViewport) / itemHeight;

			if (triggerInViewportPercentage >= self.options.minVisiblePart) {
				triggerInViewportItems.push($this);
				$this.data('triggerInViewportProcessed', true);
			}
		}
	});

	self.triggerEvent(triggerInViewportItems);
};

/**
 * vystreleni udalosti
 * @param data
 */
TriggerInViewport.prototype.triggerEvent = function(data) {
	var self = this,
		$target = self.$me;

	// cilovy element je vychozi
	if (self.options.triggerEventOn === null) {
		$target = self.$me;
	}

	// cilovy element je potomek dle selektoru v option
	else {
		$target = self.$me.find(self.options.triggerEventOn);
	}

	if (data.length > 0) {
		window.setTimeout(function(){
			$target.trigger(self.options.eventName, [{
				items: data
			}]);
		},10);
	}
};

/**
 * decide, which methods will be "public"
 */
var API = {
};


/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;


	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new TriggerInViewport(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery.triggerInViewport.js